import React, { useEffect, useRef, useState } from "react";
import HeaderModal from "components/modal/HeaderModal";
import { Button, Divider } from "antd";
import IndexModal from "components/modal";
import AnnouncementModal from "../employee-dashboard/components/AnnouncementModal";
import { ANNOUNCEMENT_COLOR_OPTIONS, TIME_FORMAT_12HM } from "variables/constants";
import { displayIcon } from "variables/icons";
import dayjs from "dayjs";
import AnnouncementView from "./AnnouncementView";
import InteractiveView from "./InteractiveView";

const AnnouncementWidget = ({ 
  announcements, 
  selectedId, 
  setSelectedId, 
  autoInterval = 4000, 
  userType = "client", 
  onRemove,
  announcementPage,
  setAnnouncementPage,
  totalAnnouncementCount
}) => {

  const timerRef = useRef(null);

  useEffect(() => {
    startTimer();

    return () => clearInterval(timerRef.current);
  }, [totalAnnouncementCount, autoInterval]);

  const startTimer = () => {
    clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setSelectedId((prev) => {
        const nextId = (prev + 1) % totalAnnouncementCount;

        setAnnouncementPage(
          Math.floor(nextId / 4)
        );

        return nextId;
      });
    }, autoInterval);
  };

  const handleClick = (id) => {
    setSelectedId(id);
    setAnnouncementPage(Math.floor(id / 4));
    startTimer();
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const selectedColorOption = ANNOUNCEMENT_COLOR_OPTIONS.find(
    (option) => option.value === selectedAnnouncement?.ann_color_class
  );

  const openModal = (item) => {
    setSelectedAnnouncement(item);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedAnnouncement(null);
    setIsModalOpen(false);
  };

  const onPopupDetails = (globalId, item) => {
    handleClick(globalId);
    openModal(item);
  };

  const hasAutoPopup = useRef(false);

  useEffect(() => {
      if (hasAutoPopup.current || !announcements?.length) {
          return;
      }

      const popupIndex = announcements.findIndex(
          item => item.ann_to_popup === 1
      );

      if (popupIndex !== -1) {
          const item = announcements[popupIndex];
          const globalId = announcementPage * 4 + popupIndex;

          hasAutoPopup.current = true;
          onPopupDetails(globalId, item);
      }
  }, [announcements]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
      {announcements.map((item, id) => {
        const globalId = announcementPage * 4 + id;
        const isSelected = selectedId === globalId;
        
        const colorOption = ANNOUNCEMENT_COLOR_OPTIONS.find(
          option => option.value === item.ann_color_class
        );

        // {item.ann_to_popup === 1 && onPopupDetails(globalId,item)}

        return (
          <div
            key={id}
            onClick={() => {
              onPopupDetails(globalId, item);
            }}
            className={`
              group relative p-2.5 rounded-lg cursor-pointer transition-all duration-300
              bg-white dark:bg-white/10 flex flex-col h-full
              border border-slate-200 dark:border-zinc-700
              ${isSelected
                ? "border-violet-400 shadow-lg shadow-violet-300/40 dark:shadow-violet-800"
                : "hover:border-violet-300 hover:shadow-sm"
              }
            `}
          >
            <button
               onClick={(e) => {
                  e.stopPropagation();
                  // onRemove(id);
                }}
              className="absolute top-1.5 right-1.5 p-0.5 rounded opacity-0 group-hover:opacity-100 bg-slate-100 dark:bg-zinc-700 hover:bg-slate-200 transition-all"
            >
              {displayIcon("X", "w-2.5 h-2.5 text-slate-800" )}
            </button>


            <div className="flex items-center gap-2 mb-2">
              <div className={`p-1.5 rounded-lg flex-shrink-0 bg-text ${colorOption?.iconClass}`}>
                {displayIcon(item?.ann_icon, "w-3 h-3")}
              </div>

              <div className="flex-1 min-w-0">
                {item.priority_level && (
                  <span className={`status-indicator ${item?.priority_level.toLowerCase()} text-[8px] px-1 py-0 mb-1`}>
                    {item.priority_level}
                  </span>
                )}
                <h5 className="text-[11px] leading-tight mb-0.5 line-clamp-1 font-semibold title-text">
                  {item.ann_title}
                </h5>
              </div>
            </div>

            <p className="text-[9px] muted-text line-clamp-2 mb-2">
              {item.ann_description}
            </p>

              <div className="flex mt-auto items-center justify-between text-[8px] muted-text">
                <div>
                  {item?.ann_event_date_from && (
                      <span className="flex items-center gap-0.5">
                        {displayIcon('Clock', "w-2.5 h-2.5")}
                        {dayjs(item.ann_event_date_from).format("MMM D, YYYY")}
                      </span>
                  )}
                </div>
                {displayIcon('ChevronRight', "w-2.5 h-2.5 text-violet-600")}
              </div>
          </div>
        );
      })}

      {isModalOpen && selectedAnnouncement && (
        <>
          {selectedAnnouncement.ann_category == 315 ? 
          <InteractiveView 
            selectedAnnouncement={selectedAnnouncement}
            isModalOpen={isModalOpen}
            closeModalHandler={closeModal}
            selectedColorOption={selectedColorOption}
          />
          : 
          <AnnouncementView
            selectedAnnouncement={selectedAnnouncement}
            selectedColorOption={selectedColorOption}
            isModalOpen={isModalOpen}
            closeModalHandler={closeModal}
            userType={userType}
          />
          }
        </>
      )}
    </div>
  );
};

export default AnnouncementWidget;
